//FIX EXTERNAL SVG THING
var ajax = new XMLHttpRequest();
ajax.open("GET", "../images/defs.svg", true);
ajax.send();
ajax.onload = function(e) {
  var div = document.createElement("div");  
  div.innerHTML = ajax.responseText;
  var svg = div.firstChild;
  document.body.insertBefore(svg, document.body.childNodes[0]);
};